document.addEventListener("DOMContentLoaded", function () {
  var product = document.querySelector(".custom_product__container");
  var shopbar = document.querySelector(".shopbar");

  window.onscroll = function () {
    var productRect = product.getBoundingClientRect();

    if (productRect.bottom < 200) {
      shopbar.classList.add("shopbar-active");
    } else {
      shopbar.classList.remove("shopbar-active");
    }

    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
      shopbar.classList.remove("shopbar-active");
    }
  };

  function addProductToCart() {
    const addButton = document.querySelector(".product-form__submit");
    const btnShopBar = document.querySelector(".btn-shop-bar");
    const btnShopBarPrime = document.querySelector(".btn-shop-bar-prime");

    btnShopBar.addEventListener("click", function () {
      addButton.click();
    });

    btnShopBarPrime.addEventListener("click", function () {
      addButton.click();
    });
  }

  addProductToCart();
});

function changeToSubscription() {
  const paymentPrime = document.getElementById("payment-method-prime");

  if (paymentPrime != null) {
    paymentPrime.click();
  }
}
